import { callPlatformAccess, getSafeAccessError } from "../../platformAccess/api/platformAccessApi";
import { invokeFinancialCallable } from "./financialCallableTransport";

export const financialDashboardApi = Object.freeze({
  callFunction: (name, input = {}, options = {}) =>
    invokeFinancialCallable(name, input, options),
  getAccess: () => callPlatformAccess("financialGetAccess"),
  getClaimsSettings: () => callPlatformAccess("financialGetClaimsSettings"),
  saveClaimsSettings: (input = {}) => callPlatformAccess("financialSaveClaimsSettings", input),
  listFinancialSettingsUsers: () => callPlatformAccess("financialListFinancialSettingsUsers"),
  getSupplierNotificationSettings: () =>
    callPlatformAccess("financialGetSupplierNotificationSettings"),
  saveSupplierNotificationSettings: (input = {}) =>
    callPlatformAccess("financialSaveSupplierNotificationSettings", input),
  listClaims: (input = {}) => callPlatformAccess("financialListClaims", input),
  listSuppliers: (input = {}) => callPlatformAccess("financialListSuppliers", input),
  getSupplier: ({ supplierId, recordScope } = {}) =>
    callPlatformAccess("financialGetSupplier", {
      ...(supplierId ? { supplierId } : {}),
      ...(recordScope ? { recordScope } : {}),
    }),
  decidePendingSupplier: (input = {}) =>
    callPlatformAccess("financialDecidePendingSupplier", input),
  updateSupplierProfile: (input = {}) =>
    callPlatformAccess("financialUpdateSupplierProfile", input),
  updateSupplierDocuments: (input = {}) =>
    callPlatformAccess("financialUpdateSupplierDocuments", input),
  archiveSupplier: (input = {}) => callPlatformAccess("financialArchiveSupplier", input),
});

export function getSafeFinancialError(error, fallback) {
  return getSafeAccessError(error, fallback);
}
